import { supabase } from './supabaseClient';

const INVALID_REASONS = {
  not_found: 'Ce lien d\'invitation est invalide.',
  inactive: 'Ce lien d\'invitation a été désactivé.',
  expired: 'Ce lien d\'invitation a expiré.',
};

export async function validateInviteCode(code) {
  const { data, error } = await supabase.rpc('check_invite_code_status', { p_code: code });

  if (error) return { valid: false, reason: 'Impossible de vérifier ce lien d\'invitation.' };
  if (data === 'valid') return { valid: true };

  return { valid: false, reason: INVALID_REASONS[data] ?? INVALID_REASONS.not_found };
}
